import jwt from 'jsonwebtoken';
import generateStoreSetters from '@/helpers/generateStoreSetters';
import { State, StateAuthentication } from './state';

const state = new State();

const store = {
  namespaced: true,
  state,
  mutations: {
    ...generateStoreSetters(state),
    clearState: (stateAuthentication: StateAuthentication): void => {
      stateAuthentication.jwtToken = null;
      stateAuthentication.decodedJwtToken = null;
    }
  },
  actions: {
    // eslint-disable-next-line
    decodeAndUpdate(storeParam: any, jwtToken: string) {
      try {
        const decodedJwtToken = jwt.decode(jwtToken);
        storeParam.commit('setJwtToken', jwtToken);
        storeParam.commit('setDecodedJwtToken', decodedJwtToken);
      } catch (e) {
        // ERROR WITH DECODE
      }
    }
  },
  modules: {},
  getters: {
    getUserId(stateAuth: StateAuthentication): string | null {
      if (!stateAuth.decodedJwtToken) {
        return null;
      }
      // eslint-disable-next-line
      return (stateAuth?.decodedJwtToken as { [key: string]: any }).userId || null;
    },
    getProfileId(stateAuth: StateAuthentication): string | null {
      if (!stateAuth.decodedJwtToken) {
        return null;
      }
      // eslint-disable-next-line
      return (stateAuth?.decodedJwtToken as { [key: string]: any }).profileId || null;
    }
  }
};

export { store as authentication };
